import axiosInstance from "./axiosInstance";


const activeIotRequests = {};
const activeGeneralRequests = {};

const ListOfRepairService = {
  async getListOfRepairsIot(projectName, companyName) {
    const key = `${companyName || ""}_${projectName || ""}`;
    if (activeIotRequests[key]) {
      return activeIotRequests[key];
    }

    const promise = (async () => {
      console.log("calling API with:", projectName, companyName);
      try {
        const response = await axiosInstance.post(`/getAllrepair-iot`, {
          project_name: projectName,
          company_name: companyName,
        });
        console.log("status:", response.status);
        console.log("response.data:", response.data);
        return response.data;
      } catch (err) {
        console.error("API error status:", err.response?.status);
        console.error("API error data:", err.response?.data); // ← error จาก server
        console.error("API error message:", err.message);
        throw err;
      } finally {
        delete activeIotRequests[key];
      }
    })();

    activeIotRequests[key] = promise;
    return promise;
  },

  async getListOfRepairsGeneral(projectName, companyName) {
    const key = `${companyName || ""}_${projectName || ""}`;
    if (activeGeneralRequests[key]) {
      return activeGeneralRequests[key];
    }

    const promise = (async () => {
      console.log("calling API with:", projectName, companyName);
      try {
        const response = await axiosInstance.post(`/getAllrepair-general`, {
          project_name: projectName,
          company_name: companyName,
        });
        console.log("status:", response.status);
        console.log("response.data:", response.data);
        return response.data;
      } catch (err) {
        console.error("API error status:", err.response?.status);
        console.error("API error data:", err.response?.data); // ← error จาก server
        console.error("API error message:", err.message);
        throw err;
      } finally {
        delete activeGeneralRequests[key];
      }
    })();

    activeGeneralRequests[key] = promise;
    return promise;
  },

  getRepairIotById: async (id) => {
    const response = await axiosInstance.get(`/repair-iot/technician/${id}`);
    console.log("getRepairIotById response:", response.data);
    return response.data;
  },

  getRepairGeneralById: async (id) => {
    const response = await axiosInstance.get(`/repair-general/technician/${id}`);
    console.log("getRepairGeneralById response:", response.data);
    return response.data;
  },

  async getCalendar(companyName, projectName, modelName) {
    console.log("calling API with:", companyName, projectName, modelName);

    try {
      const response = await axiosInstance.post(`/calendar-repairs`, {
        company_name: companyName,
        project_name: projectName,
        model_name: modelName,
      });
      console.log("status:", response.status);
      console.log("response.data:", response.data);
      return response.data;
    } catch (err) {
      console.error("API error status:", err.response?.status);
      console.error("API error data:", err.response?.data); // ← error จาก server
      console.error("API error message:", err.message);
      throw err;
    }
  },
  
};

export default ListOfRepairService;
